<template>
  <div
    class="max-h-screen min-h-screen bg-transparent w-full h-full flex flex-col justify-end overflow-hidden"
  >
    <div class="flex flex-col w-full px-4 pt-2 pb-4">
      <Transition name="fade" mode="out-in">
        <div
          v-if="currentNotice"
          :key="currentNotice.id"
          class="notice-card flex flex-col gap-1.5 w-full rounded-3xl bg-white p-4 shadow-lg cursor-pointer"
          @click="closeNotice"
        >
          <div class="flex items-center gap-1">
            <img width="16" height="16" :src="logo" class="size-4" />
            <span class="text-l-medium text-text-active">A HUB</span>
          </div>
          <div class="text-text-important-default">{{ currentNotice.title }}</div>
          <div class="text-text-body-default">{{ currentNotice.message }}</div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import logo from '@/assets/images/header/user/avatar-loggedIn.png'
  import { computed, nextTick, onMounted, ref } from 'vue'

  interface NoticeItem {
    id: number
    title: string
    message: string
  }

  const notices = ref<NoticeItem[]>([])
  const currentNotice = computed(() => notices.value[0] ?? null)
  const canClose = ref(false)
  const pendingClose = ref(false)

  function closeNotice() {
    if (canClose.value) {
      // 完全显示中，直接关闭
      window.electronAPI?.closeNotice()
    } else {
      // 渐入过程中，标记为待关闭，渐入完成后立即执行
      pendingClose.value = true
    }
  }

  onMounted(() => {
    window.electronAPI?.onNoticeActivated((data: any) => {
      if (Array.isArray(data)) {
        notices.value = data.map((n: any) => ({
          id: n.id,
          title: n.title,
          message: n.message,
        })) as NoticeItem[]
        // 新消息出现时禁止关闭
        canClose.value = false
        pendingClose.value = false
        // 等渐入动画完成（0.35s）后启用关闭
        nextTick(() => {
          setTimeout(() => {
            canClose.value = true
            // 如果渐入过程中被点击过，立即关闭
            if (pendingClose.value) {
              pendingClose.value = false
              window.electronAPI?.closeNotice()
            }
          }, 400)
        })
      }
    })
  })
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
